import ky, { HTTPError } from "ky"
import type { Input as KyInput, KyInstance } from "ky"

import { stringifyQuery } from "@finq/app-base/lib/queryParams"

import { KyHTTPError } from "./api-types"

export class KyAxiosWrapper {
  constructor(private instance: KyInstance) {}

  protected async method<ResponseType extends any>(
    method: "post" | "get" | "put" | "delete" | "patch",
    url: KyInput,
    { responseType = "json", ...config }: KyOptions = {}
  ) {
    url = typeof url === "string" && url.startsWith("/") ? url.substring(1) : url

    try {
      const response = await this.instance(url, {
        ...config,
        method,
        searchParams: stringifyQuery(config.params),
      })
      let data: any

      if (responseType === "json") {
        data = await response.json<any>()
      } else if (responseType === "blob") {
        data = await response.blob()
      } else {
        data = await response.json<any>()
      }
      return { response, data }
    } catch (error) {
      if (error instanceof HTTPError) {
        const errorData = await error.response.json()
        throw new KyHTTPError(error.response, error.request, error.options, errorData.error || {})
      }
      throw error
    }
  }

  public get(url: KyInput, config: KyOptions = {}) {
    return this.method("get", url, config)
  }

  public async post(url: KyInput, data: any, config: KyOptions = {}) {
    return this.method("post", url, { json: data, ...config })
  }

  public async put(url: KyInput, data: any, config: KyOptions = {}) {
    return this.method("put", url, { json: data, ...config })
  }

  public async patch(url: KyInput, data: any, config: KyOptions = {}) {
    return this.method("patch", url, { json: data, ...config })
  }

  public async delete(url: KyInput, config: KyOptions = {}) {
    return this.method("delete", url, config)
  }
}
